import { render } from "./VersioningComp.vue?vue&type=template&id=300fe0d4&ts=true"
import script from "./VersioningComp.vue?vue&type=script&lang=ts"
export * from "./VersioningComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__